import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9.03",
  height: "10.535"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "delete_filled",
  transform: "translate(-3 -1.5)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2503",
    d: "M6.005 13.523h.753V7.879h-.753zm1.881 0h.753V7.879h-.753zm1.881 0h.753V7.879h-.752zm-5.267.441a.722.722 0 0 0 .753.687h6.02a.722.722 0 0 0 .753-.687V6.75H4.5z",
    class: "cls-1",
    transform: "translate(-.747 -2.616)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2504",
    d: "M8.644 2.629a1.129 1.129 0 1 0-2.258 0H3v.753h9.03v-.753z",
    class: "cls-1"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };